"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayAsDecimal = function (s, nDecimal) {
    if (!(typeof s).match(/string|number/))
        return "";
    nDecimal = typeof nDecimal === "number" ? (nDecimal < 0 ? 0 : nDecimal) : undefined;
    s = (s + "").trim().replace(',', '');
    var fl = parseFloat(s);
    return isNaN(fl) ? (s) : (nDecimal === undefined ? (fl % 1 === 0 ? (parseInt(s) + ".0") : (s)) : (fl.toFixed(nDecimal)));
};
